export const accountSettingNavbarItems = {
  admin: [
    {
      label: "Account",
      icon: "bx bx-user",
      path: "/account-setting/account",
    },
    {
      label: "Security",
      icon: "bx bx-lock-alt",
      path: "/account-setting/security",
    },
  ],
  member: [
    {
      label: "Account",
      icon: "bx bx-user",
      path: "/account-setting/account",
    },
    {
      label: "Security",
      icon: "bx bx-lock-alt",
      path: "/account-setting/security",
    },
    {
      label: "Billing & Plans",
      icon: "bx bx-detail",
      path: "/account-setting/billing-and-plans",
    },
  ],
  doctor: [
    {
      label: "Account",
      icon: "bx bx-user",
      path: "/account-setting/account",
    },
    {
      label: "Security",
      icon: "bx bx-lock-alt",
      path: "/account-setting/security",
    },
  ],
};
